import { render, staticRenderFns } from "./userIcon.vue?vue&type=template&id=7e39bb72&scoped=true&"
import script from "./userIcon.vue?vue&type=script&lang=js&"
export * from "./userIcon.vue?vue&type=script&lang=js&"
import style0 from "./userIcon.vue?vue&type=style&index=0&id=7e39bb72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e39bb72",
  null
  
)

export default component.exports